import { TypeVoie } from './TypeVoie';

export class TypeAdresse {

  public lieuDit: string;

  public ville: string;

  public cx: number;

  public voie_e: TypeVoie;

  public cp: string;

  public cp_e: string;

  public voie: TypeVoie;

  public bp: number;

  public pays: string;

  constructor() {
    this.lieuDit = '';
    this.ville = '';
    this.cx = 0;
    this.voie_e = new TypeVoie();
    this.cp = '';
    this.cp_e = '';
    this.voie = new TypeVoie();
    this.bp = 0;
    this.pays = null;

  }
}
